import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: 'AIzaSyD-Jt-TDXswtsj_o1psY9se8P88yhk4bp4',
    authDomain: 'tabexseries-web-push.firebaseapp.com',
    projectId: 'tabexseries-web-push',
    storageBucket: 'tabexseries-web-push.firebasestorage.app',
    messagingSenderId: '780930526920',
    appId: '1:780930526920:web:bdb6b5c5c8943f625ebffd',
    measurementId: 'G-WNWTHWKTJG',
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);
